export class VerifyBranchdata {
    valid: boolean;
    info: string;
    branchName: string;
    isExist: boolean;
    isSkip: boolean;
    fullName: string;
    mobilePhone: string;
    groupId: string;
    orderId: string;
    counter: string;
    status: number;
    zaloChannel: boolean;
    latitude: number;
    longitude: number;
}

export class Customer {
    isPriority: boolean;
    isVip: boolean;
    isForeigner: boolean;
    customerCode: string;
    email: string;
    dateOfBirth: Date;
    orgCode: string;
    phone: string;
    ewallName: string;
    nationalId: string;
    legalName: string;
    fullName: string;
    rateLevel: string;
    productGroupId: number;
    bookingId: number;
    customerType: string;
    isKhVangLai: boolean;
    ProductGroupId: number;
    visitorId: string;
    branchCode: string;
    isZalo: boolean;
    isRequestFromCVTV: boolean;
}

export class ProductGroup {
    allowBooking: boolean;
    branchCode: string;
    creationTime: Date;
    creatorUserId: number;
    deleterUserId: number;
    deletionTime: Date;
    description: string;
    descriptionEn: string;
    groupName: string;
    iconPath: string;
    id: number;
    isActive: boolean;
    isDeleted: boolean;
    lastModificationTime: Date;
    lastModifierUserId: number;
    name: string;
    nameEn: string;
    normalLine: string;
    order: number;
    products: Product[];
    vipLine: string;
}

export class Product {
    code: string;
    name: string;
    description: string;
    avgDuration: number;
    linkUrl: string;
    order: number;
    isActive: true;
    allowBooking: true;
    icon: string;
    productGroupId: number;
    formCode: string;
    formName: string;
    isRPA: boolean;
    displayCodeName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: Date;
    lastModificationTime: Date;
    lastModifierUserId: number;
    creationTime: Date;
    creatorUserId: number;
    id: number;
}

export class ApiResponse<T> {
    result: ResponseResult<T>;
}

export class ResponseResult<T> {
    isSuccess: boolean;
    value: ResponseResultValue<T>;
    response: string;
    error: any;
    request: any;
    messageError: string;
}

export class ResponseResultValue<T> {
    result: T;
    targetUrl: any;
    success: boolean;
    error: any;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}